import { render, staticRenderFns } from "./QEditNavMenuItem.vue?vue&type=template&id=11dabf38&"
import script from "./QEditNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./QEditNavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports